import Vue from 'vue'
import Router from 'vue-router'
import ProgressBar from '~/components/progress-bar.vue'
import cookie from '~/utils/cookie'

// 全局进度条
const bar = Vue.prototype.$bar = new Vue(ProgressBar).$mount()
document.body.appendChild(bar.$el)

Vue.use(Router)

const routes = [
  {
    path: '/404',
    component: () => import('../views/404.vue')
  },
  {
    path: '*',
    redirect: '/404'
  },
  // 首页
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    component: () => import('../views/login')
  },
  // 科研云后台首页
  {
    path: '/index',
    component: () => import('../views/index'),
    redirect: '/index/applet',
    beforeEnter: (to, from, next) => {
      let token = cookie.get('token')
      if (token) {
        return next()
      }
      next('/login')
    },
    children: [
      {
        // 小程序管理
        path: 'applet',
        component: () => import('../views/index/applet'),
        redirect: '/index/applet/owned',
        children: [
          {
            // 已有小程序
            path: 'owned',
            component: () => import('../views/index/applet/owned/index.vue')
          },
          {
            // 待审核的小程序
            path: 'check',
            component: () => import('../views/index/applet/check/index.vue')
          },
          {
            // 添加小程序
            path: 'add',
            component: () => import('../views/index/applet/owned/addApplet/index.vue')
          },
          {
            // 更新小程序
            path: 'update/:id',
            component: () => import('../views/index/applet/owned/updateApplet/index.vue')
          },
          {
            // 审核用户提交的小程序 看详情
            path: 'checkDetails/:id',
            component: () => import('../views/index/applet/check/checkDetails/index.vue')
          }
        ]
      },
      {
        // 专题管理
        path: 'topics',
        component: () => import('../views/index/topics/index.vue'),
        redirect: '/index/topics/list',
        children: [
          {
            // 专题列表
            path: 'list',
            component: () => import('../views/index/topics/topicsList/index.vue')
          },
          {
            // 添加专题
            path: 'add',
            component: () => import('../views/index/topics/addTopics/index.vue')
          },
          {
            // 更新专题 获取详情
            path: 'update/:id',
            component: () => import('../views/index/topics/updateTopics/index.vue')
          }
        ]
      },
      {
        // 专题管理
        path: 'swiper',
        component: () => import('../views/index/swiper/index.vue')
      }
    ]
  }
  /* // 后台管理首页
  {
    path: '/index',
    component: () => import('../views/index'),
    redirect: '/index/dataServer',
    beforeEnter: (to, from, next) => {
      let token = cookie.get('token')
      if (token) {
        return next()
      }
      next('/login')
    },
    children: [
      {
        // 数据服务模块
        path: 'dataServer',
        component: () => import('../views/index/dataServer'),
        redirect: '/index/dataServer/pendingOrder',
        children: [
          {
            // 待处理订单
            path: 'pendingOrder',
            component: () => import('../views/index/dataServer/pending')
          },
          {
            // 处理中订单
            path: 'processedOrder',
            component: () => import('../views/index/dataServer/processed')
          },
          {
            // 历史订单
            path: 'historyOrder',
            component: () => import('../views/index/dataServer/history')
          },
          {
            // 历史订单
            path: 'rejectOrder',
            component: () => import('../views/index/dataServer/reject')
          }
        ]
      }
    ]
  } */
  /* {
    // 控制台
    path: '/console',
    // 目前，一进入控制台 跳转到账号管理界面
    redirect: '/console/account',
    component: () => import('../views/console'),
    beforeEnter: (to, from, next) => {
      let token = cookie.get('token')
      if (token) {
        return next()
      }
      location.href = getLoginPath()
    },
    children: [
      {
        // 账号管理
        path: 'account',
        component: () => import('../views/console/account')
      },
      {
        // 基本信息
        path: 'record',
        component: () => import('../views/console/record')
      }
    ]
  } */
]

const router = new Router({
  mode: 'history',
  routes,
  linkActiveClass: 'link-active',
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  bar.start()
  next()
})

router.afterEach((to, from) => {
  bar.finish()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js